<template>
    <section id="index">
        <section class="banner_silder">
            <swiper :options="swiperOptionDefault" ref="mySwiper">
                <swiper-slide v-for="(banner,index) in banners" :key="index">
                    <a
                        :href="banner.Url ? banner.Url : 'javascript:;'"
                        :target="banner.Url ?　'_blank':　'_self'"
                        class="banner"
                        :style="{ backgroundImage: `url(${screenWidth > 767 ? banner.Image:banner.MobileImage})`}"
                    ></a>
                </swiper-slide>
                <div class="swiper-button-prev banner-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next banner-button-next" slot="button-next"></div>
            </swiper>
            <!-- 2024 新年限定 -->
            <!-- <video autoplay muted loop>
                <source  src="/static/mp4/Blue Chinese New Year Greeting Card.mp4" type="video/mp4">
            </video> -->
        </section>
        <section class="news trs_flex" :style="{ backgroundImage: `url(${news.img})`}">
            <div class="container idx_flex">
                <div class="news_box">
                    <Title
                        :en="news.title.en"
                        :chtFirst="news.title.chtFirst"
                        :chtSecond="news.title.chtSecond"
                        :center="news.title.center"
                    />
                    <div class="list_box">
                        <NewsList
                            v-for="(news, index) in mock.news"
                            :key="index"
                            :urlId="news.Id"
                            :date="news.StartOn"
                            :category="news.CategoryTitle"
                            :content="news.Title"
                        />
                    </div>
                </div>
                <div class="silhouette_box">
                    <Title
                        en="Activity silhouette"
                        chtFirst="活動"
                        chtSecond="花絮"
                        :center="news.title.center"
                    />
                    <div class="list_box">
                        <!-- 22/01/04 強制手動置頂內容 -->
                        <a class="silhouetteCard" @click.prevent="openPop(3)">
                            <div class="title">2023 Retina Club 春季會</div>
                            <div class="image">
                            <img src="/static/images/春季會.png" />
                            </div>
                        </a>
                        <!-- <a class="silhouetteCard" @click.prevent="openPop(1)">
                            <div class="title">The 2022 Asia Retina Congress.</div>
                            <div class="image">
                            <img src="https://img.youtube.com/vi/a4s8pVEJ4kU/hqdefault.jpg" />
                            </div>
                        </a>
                        <a class="silhouetteCard" @click.prevent="openPop(2)">
                            <div class="title">視網膜醫學會十周年紀錄影片</div>
                            <div class="image">
                            <img src="https://img.youtube.com/vi/DPrqvvLjwJg/hqdefault.jpg" />
                            </div>
                        </a> -->
                        <!-- 22/01/04 強制手動置頂內容 -->
                        <template v-for="(silhouette,index) in mock.activity.silhouettes">
                            <silhouetteCard
                            v-if="index < 3"                            
                            :key="silhouette.Id"
                            :propdata="silhouette"
                        />
                        </template>
                        <!-- <silhouetteCard
                            v-for="(silhouette,index) in mock.activity.silhouettes"
                            :key="silhouette.Id"
                            :propdata="silhouette"
                        /> -->
                    </div>
                </div>
            </div>
        </section>
        <section class="stroke trs_flex">
            <div class="container">
                <div class="title_box">
                    <div class="title">
                        <Title
                            :en="stroke.title.en"
                            :chtFirst="stroke.title.chtFirst"
                            :chtSecond="stroke.title.chtSecond"
                            :center="stroke.title.center"
                        />
                        <!-- <div
                            class="text gray_light"
                        >提供完整國內外研討會及每年各項學術年會與地會開辦及投稿日期時間，以便各位使用者查詢與確認，若有任何問題，可聯絡通知我們，以便後續協助與服務，謝謝!!</div> -->
                    </div>
                    <!-- <div class="calendar">
                        <a href="/Academic/Calendar" class="border">
                            <div class="icon">
                                <i class="icon icon-calendar"></i>
                            </div>
                            <div>查看行事曆</div>
                            <div>View calendar</div>
                        </a>
                    </div> -->
                </div>
                <div id="videoplatform">
                    <section class="list_box">
                <div
                    class="list"
                >
                    <div class="item" v-for="(item,index) in videos" :key="index">
                        <Video :data="item" :isPublic="true" :isIndex="true"></Video>
                    </div>
                </div>
                <notfound v-if="videos.length == 0" info="目前尚未開放影像衛教，"></notfound>
                </section>

                </div>
                <!-- <div class="tab">
                    <ul class="tab_button">
                        <li class="link_tab active" @click="chooseTab($event,'All')" ref="allweek">
                            <div>All Week</div>
                            <div>{{$moment().startOf('month').format("YYYY.MM.DD") + "-" + $moment().endOf('month').format("DD")}}</div>
                        </li>
                        <li
                            class="link_tab"
                            v-for="(week,index) in computedWeek"
                            :key="index"
                            @click="chooseTab($event,week)"
                            ref="week"
                        >
                            <div>Week 0{{index + 1 }}</div>
                            <div>{{week.startTime + "-" + week.endTime}}</div>
                        </li>
                    </ul>
                    <div class="tab_content">
                        <div class="month">{{new Date().getFullYear() + "年" + Month + "月"}}時間表</div>
                        <div
                            class="date"
                            v-if="IshasTime"
                        >{{$moment(Week.startValue).locale('zh-tw').format('LL')}}-{{Week.endTime}}日 活動/會議行程</div>
                        <ul class="classification">
                            <li
                                class="item"
                                v-for="(area,index) in tabArea"
                                :key="area.Id"
                                :class="{'active':index ===0}"
                                @click="chooseAreaTab($event,area.Id)"
                                ref="area"
                            >
                                <div>{{area.Title}}</div>
                            </li>
                        </ul>
                        <div class="list" v-if="showevents.length > 0">
                            <LsitCard
                                v-for="(event,index) in showevents"
                                :key="index"
                                :event="event"
                                :categoryId="event.CategoryName"
                                :categoryList="tabArea"
                            ></LsitCard>
                        </div>
                        <notfound v-if="showevents.length == 0" info="目前沒有舉辦活動，若想了解更多活動訊息，" infoHTML="請前往<a href='/Academic/Calendar'>行事曆</a>進行查詢，謝謝!"></notfound>
                    </div>
                </div> -->
            </div>
        </section>
        <section class="slider">
            <swiper :options="swiperOptionAD" ref="swiperAD">
                <!-- slides -->
                <swiper-slide v-for="(ad, index) in advertising" :key="ad.Id">
                    <a class="swiperAd" :href="ad.Url" target="_blank">
                        <img :src="screenWidth > 767?ad.Image:ad.MobileImage" :alt="ad.Title" />
                    </a>
                </swiper-slide>
                <!-- Optional controls -->
                <div class="swiper-button-prev small-image-prev" slot="button-prev"></div>
                <div class="swiper-button-next small-image-next" slot="button-next"></div>
                <div class="swiper-scrollbar" slot="scrollbar"></div>
            </swiper>
        </section>
        <Popup v-if="videoOpen" @closePopup="closePop">
            <div class="video">
            <iframe v-if="nowVideo == 1" width="560" height="315" src="https://www.youtube.com/embed/a4s8pVEJ4kU?autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            <video v-else-if="nowVideo == 3" src="/static/mp4/2023 Retina Club 春季會.mp4" controls style="width:100%;"></video>
            <iframe v-else width="560" height="315" src="https://www.youtube.com/embed/DPrqvvLjwJg?autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
        </Popup>
    </section>
</template>
<script>
// require styles
import "swiper/dist/css/swiper.css";
import LsitCard from "@/components/listCard";
import Title from "@/components/Title";
import NewsList from "@/components/index/NewsList";
import NewsCard from "@/components/index/NewsCard";
import silhouetteCard from "@/components/index/silhouetteCard";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import NewsApi from "@/service/news.js";
import HomeApi from "@/service/home.js";
import ActivityApi from "@/service/activity.js";
import Popup from "@/components/popup"; // 22/01/04 影片播放用 
import API from "@/service/conference"; // 22/03/24 取得衛教影片
import Video from "@/components/information/videoCard";
export default {
  name: "index",
  props: ["api"],
  components: {
    Title,
    NewsList,
    NewsCard,
    silhouetteCard,
    swiper,
    swiperSlide,
    LsitCard,
    Popup, // 22/01/04 影片播放用 
    Video
  },
  data() {
    return {
        videoOpen: false,
      window: {
        width: 0,
        height: 0
      }, //畫面寬高度
      screenWidth: document.documentElement.clientWidth,
      banners: [],
      news: {
        img: "../static/images/index/banner2.jpg",
        title: {
          en: "Latest News",
          chtFirst: "最新",
          chtSecond: "消息",
          center: false
        }
      },
    //   stroke: {
    //     title: {
    //       en: "Event / meeting itinerary",
    //       chtFirst: "學術",
    //       chtSecond: "活動",
    //       center: false
    //     }
    //   },
      stroke: {
        title: {
          en: "Video",
          chtFirst: "影像",
          chtSecond: "衛教",
          center: false
        }
      },
      advertising: [],
      mock: {
        news: [],
        activity: {
          teachs: [
            {
              img: "../static/images/index/teach/teach.jpg",
              title: "台灣視網膜學教授學術醫學會2019春季學術研討會",
              date: "2019-03-24 ~ 2019-04-01",
              place: "台大醫院國際會議中心",
              contribute: "2018/06/20 ~ 2018/08/03",
              teach: true
            },
            {
              img: "../static/images/index/teach/teach.jpg",
              title: "台灣視網膜學教授學術醫學會2019春季學術研討會",
              date: "2019-03-24 ~ 2019-04-01",
              place: "台大醫院國際會議中心",
              contribute: "2018/06/20 ~ 2018/08/03",
              teach: true
            },
            {
              img: "../static/images/index/teach/teach.jpg",
              title: "台灣視網膜學教授學術醫學會2019春季學術研討會",
              date: "2019-03-24 ~ 2019-04-01",
              place: "台大醫院國際會議中心",
              contribute: "2018/06/20 ~ 2018/08/03",
              teach: true
            }
          ],
          silhouettes: []
        }
      },
      swiperOptionTeach: {
        autoplay: true,
        navigation: {
          nextEl: ".teach_swiper_next",
          prevEl: ".teach_swiper_prev"
        }
      },
      swiperOption: {
        autoplay: true,
        navigation: {
          nextEl: ".silhouette_swiper_next",
          prevEl: ".silhouette_swiper_prev"
        }
      },
     //   swiperOptionAD: {
      //     loop: true, // 循環
      //     centeredSlides: true, // 顯示置中
      //     slidesPerView: SwiperShow, // 顯示數量
      //     effect: SwiperEffect, // 特效
      //     navigation: {
      //       nextEl: ".swiper-button-next",
      //       prevEl: ".swiper-button-prev"
      //     }
      //   },
      tabWeeks: [],
      tabArea: [],
      events: [
        {
            Id: "7d602fda-f6e5-46fb-9837-681e3268fb80",
            Title: "2016年第N次Retina Club 學術演講會 - 報名開始囉!!",
            Image: "https://retinasociety.blob.core.windows.net/activity/7d602fda-f6e5-46fb-9837-681e3268fb80/456122f8c4b742ee82ee6cb859dcb4e3.png",
            Introduction: "2016年第N次Retina Club 學術演講會 - 報名開始囉!!2016年第N次Retina Club 學術演講會 - 報名開始囉!!2016年第N次Retina Club 學術演講會 - 報名開始囉!!",
            Description: null,
            Content: null,
            DocumentFile: null,
            Location: "西門町",
            Organizer: "台北市政府",
            CoOrganizer: null,
            RequirePayment: false,
            RequireRegister: false,
            RegisterStartOn: "2019-08-13T00:00:00",
            RegisterEndOn: "2019-08-22T00:00:00",
            StartOn: "2019-08-01T00:00:00",
            EndOn: "2019-08-31T00:00:00",
            CategoryId: "bb941e83-cedd-4bc1-b2a2-127688844b49",
            FeeItems: []
        }
      ],
      showevents:[],
      Month:0,
      Week:[],
      WeekStartDate:"",
      WeekEndDate:"",
      ActivityCategoryId:"",
      IshasTime:false,
      videos: [],
      nowVideo: 1
    };
  },
  methods: {
    chooseTab(e,week) {
        const vm = this;
        vm.$refs.week.forEach(item => {
            if (item.classList.contains("active")) {
                item.classList.remove("active");
            }
        });
        if(vm.$refs.allweek.classList.contains("active")){
            vm.$refs.allweek.classList.remove('active');
        }
        e.currentTarget.classList.add("active");
        if(week == 'All'){
            vm.WeekStartDate = vm.$moment().startOf('month').format("YYYY-MM-DD").valueOf();
            vm.WeekEndDate = vm.$moment().endOf('month').format("YYYY-MM-DD").valueOf();
        }else{
            vm.Week = week;
            vm.WeekStartDate = vm.$moment(week.startValue).format("YYYY-MM-DD").valueOf();
            vm.WeekEndDate = vm.$moment(week.endValue).format("YYYY-MM-DD").valueOf();
        }
       
        vm.IshasTime = true;
        vm.SortEvents();
    },
    chooseAreaTab(e,categoryId) {
        const vm = this;
        
        vm.$refs.area.forEach(item => {
            if (item.classList.contains("active")) {
            item.classList.remove("active");
            }
        });
        e.currentTarget.classList.add("active");
        vm.ActivityCategoryId = categoryId;
        vm.SortEvents();

    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    SortEvents(){
        const vm = this;
        // console.log(vm.WeekStartDate);
        let _event = [];
        vm.showevents = [];
        if(!vm.IshasTime){
            vm.WeekStartDate = vm.$moment().startOf('month').format("YYYY-MM-DD").valueOf();
            vm.WeekEndDate = vm.$moment().endOf('month').format("YYYY-MM-DD").valueOf();
        }
        _event = vm.events.filter(item => {
            if(vm.$moment(item.RegisterStartOn).format("YYYY-MM-DD").valueOf() >= vm.WeekStartDate && vm.$moment(item.RegisterStartOn).format("YYYY-MM-DD").valueOf() <= vm.WeekEndDate){
                return item;
            }
            if(vm.$moment(item.RegisterEndOn).format("YYYY-MM-DD").valueOf() >= vm.WeekStartDate && vm.$moment(item.RegisterStartOn).format("YYYY-MM-DD").valueOf() <= vm.WeekEndDate){
                return item;
            }
        }).filter(item=>{
            if(vm.ActivityCategoryId == ''){
                return item;
            }else{
                if(item.CategoryId == vm.ActivityCategoryId){
                    return item;
                }
            }
        });
        vm.showevents = _event;
    },
    openPop(id) {
        // 22/01/04 播放影片用
        const vm = this;
        vm.nowVideo = id
        vm.videoOpen = true;
    },
    closePop() {
        // 22/01/04 播放影片用
        const vm = this;
        vm.videoOpen = false;
    },
    getVideo() {
        const vm = this;
        API.getVideoList({
                    page: 1,
                    count: 3,
                    isPublic: true
                }).then(result => {
                    if(result) {
                        vm.videos = result.Data.Videos;
                    }
                });
    }
  },
  computed: {
    computedWeek() {
        const vm = this;
        
        const dt = new Date();
        let yr = dt.getFullYear();
        let mh = 10; // 0~11
        let firstWeek = new Date(yr, mh, 1).getDay();
    //   console.log("這個月第一天是星期", firstWeek);
        let lastDay = 32 - new Date(yr, mh, 32).getDate();
        let fullDate = dt.getDate();
    //   console.log(`這個月有${lastDay}天`);
        let Num;
        if (firstWeek == 0) {
            Num = 7;
        } else {
            Num = firstWeek;
        }
        let total = Math.ceil((lastDay - (7 - Num - 1)) / (7 - 1));//總週數
        

        const firstDate = vm.$moment().startOf('month').valueOf(); //每個月第一天時間戳

        const firstShowDate = vm.$moment().startOf('month').format("YYYY-MM-DD"); //每個月第一天

        const endDate =  vm.$moment().endOf('month').valueOf(); //每個月最後一天時間戳
        const endShowDate =  vm.$moment().endOf('month').format("YYYY-MM-DD"); //每個月最後一天

        //計算本日在第幾周
        const getMonthWeek = (a, b, c) => {
            const date = new Date(a, parseInt(b) - 1, c),
                w = date.getDay(),
                d = date.getDate();
            return Math.ceil((d + 6 - w) / 7);
        };

        const thisWeek = getMonthWeek(yr,mh,fullDate);

        const  getCurrentWeek = () => {
            let start = vm.$moment().weekday(1).format('YYYY-MM-DD'); //本周一
            let startValue = vm.$moment().weekday(1).valueOf();
            if(startValue < firstDate){
                start = firstShowDate;
                startValue = firstDate;
            }
            const end = vm.$moment().weekday(7).format('YYYY-MM-DD'); //本周日
            return {
                startTime: vm.$moment(startValue).format('YYYY.MM.DD'),
                startValue: start,
                endTime: vm.$moment().weekday(7).format('DD'),
                endValue:end
            }
        };
        const getLastWeek = (i) => {
            let weekOfDay = parseInt(vm.$moment().format('E'));//计算今天是这周第几天
            let last_monday = vm.$moment().subtract(weekOfDay + 7 * i - 1, 'days').format('YYYY-MM-DD');//周一日期
            console.log(last_monday);
            let lastmodayValue  = vm.$moment().subtract(weekOfDay + 7 * i - 1, 'days').valueOf(); //周一時間戳
            if(lastmodayValue < firstDate){
                last_monday = firstShowDate;
            }
            let last_sunday = vm.$moment().subtract(weekOfDay + 7 * (i - 1), 'days').format('YYYY-MM-DD');//周日日期
            
            return {
                startTime: vm.$moment(last_monday).format('YYYY.MM.DD'),
                startValue: last_monday,
                endTime: vm.$moment(last_sunday).format('DD'),
                endValue:last_sunday
            }
        }

        const getNextWeek = (i) => {
            let weekOfDay = parseInt(vm.$moment().format('E'));//计算今天是这周第几天
            let next_monday = vm.$moment().add((7 - weekOfDay) + 7 * (i - 1) + 1, 'days').format('YYYY-MM-DD');//周一日期
            let next_sunday = vm.$moment().add((7 - weekOfDay) + 7 * i, 'days').format('YYYY-MM-DD');//周日日期
            let next_sundayValue  = vm.$moment().add((7 - weekOfDay) + 7 * i, 'days').valueOf(); //周日時間戳
            if(next_sundayValue > endDate){
                next_sunday = endShowDate;
            }
            return {
                startTime: vm.$moment(next_monday).format('YYYY.MM.DD'),
                startValue: next_monday,
                endTime: vm.$moment(next_sunday).format('DD'),
                endValue:next_sunday
            }
        }
        
        let arr = [];

        for(let i = thisWeek;i > 1;i--){
            arr.push(getLastWeek(i));
        }
        arr.push(getCurrentWeek());

        for(let i = 1 ;i <= total - thisWeek;i++){
            arr.push(getNextWeek(i));
        }

        vm.WeekStartDate = vm.$moment(arr[0].startValue,"YYYY-MM-DD").valueOf();
        vm.WeekEndDate = vm.$moment(arr[0].endValue,"YYYY-MM-DD").valueOf();
        // console.log(arr);
        return arr;
    },
    swiperAD() {
      return this.$refs.swiperAD.swiper;
    },
    swiperOptionAD() {
      //   console.log(this.window.width);
      let effect = String;
      let show = Number;
      if (this.window.width < 768) {
        effect = "none";
        show = 1;
      } else {
        effect = "coverflow";
        show = 4;
      }
      let obj = {
        init: false,
        loop: true, // 循環
        centeredSlides: true, // 顯示置中
        slidesPerView: show, // 顯示數量
        effect: effect, // 特效
        navigation: {
          nextEl: ".small-image-prev",
          prevEl: ".small-image-next"
        }
      };
      return obj;
    },
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    swiperOptionDefault() {
      let obj = {
        init: false,
        loop: true, // 循環
        centeredSlides: true, // 顯示置中
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        effect: "fade",
        navigation: {
          nextEl: ".banner-button-next",
          prevEl: ".banner-button-prev"
        }
      };
      return obj;
    }
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    const vm = this;
    vm.Month = parseInt(vm.$moment().format("MM"));//當月

    if (process.env.NODE_ENV === "production") {
      //新聞分類
      NewsApi.getNewsCategory().then(result => {
        let Categories = result.Data;
        //新聞清單API
        NewsApi.getNewsList({ page: 1, count: 5 }).then(result => {
          let NewsList = result.Data.News;
          NewsList.forEach(item => {
            // item.StartOn = item.StartOn.split("T")[0]; //只獲得年月日
            Categories.forEach(Category => {
              //比較分類ID 新增分類標題
              if (item.CategoryId == Category.Id) {
                item.CategoryTitle = Category.Title;
              }
            });
          });
          // console.log(NewsList);
          vm.mock.news = NewsList;
          // console.log(vm.mock.news);
        });
      });

      //首頁BannerAPI
        HomeApi.getBanners({ count: 5 }).then(res => {
            if (res.Ok) {
            vm.banners = res.Data;
            }
        });
        //活動分累
        ActivityApi.getActivityCategory().then(res => {
            if (res.Ok) {
                let arr = [
                    {
                        Id: "",
                        Name: "All",
                        Title: "全部"
                    }
                ];
                vm.tabArea = arr.concat(res.Data);
            }
        }).then(() => {
            //獲取完分類之後 獲取這個月的活動
            ActivityApi.getActivityListMonth({Month:vm.Month}).then(activity => {
                if(activity.Ok){
                    vm.events = activity.Data.Activities;
                    
                    let thisWeek = vm.computedWeek[0];
                    // console.log(thisWeek);
                    vm.Week = thisWeek;
                    vm.events.forEach((item,index)=>{
                        vm.tabArea.forEach(tab=>{
                            if(tab.Id == item.CategoryId){
                                item.CategoryName = tab.Title;
                            }
                        });
                        vm.$set(vm.showevents, index, item);
                    });
                }
            });
        });
        ActivityApi.getAlbumList({page:1,count:4}).then(res=>{
            if(res.Ok){
                vm.mock.activity.silhouettes = res.Data.Albums;
            }
        });
        HomeApi.getAdvertisements().then(res=>{
            if(res.Ok){
                vm.advertising = res.Data;
            }
        });
        
    } else {
        //假資料集合地
        vm.banners = [
            {
                Active: true,
                CreateOn: "2019-08-08T17:38:31.3069941",
                Deletion: false,
                EndOn: "2019-08-31T00:00:00",
                Hash: "75bad2c2-3ec9-4b15-84ce-af7398c35134",
                Id: "6b003786-1c03-4dfd-ab22-d2f8ce01d136",
                Image: "https://retinasociety.blob.core.windows.net/banner/6b003786-1c03-4dfd-ab22-d2f8ce01d136/2f4e29fa049246d2b933635fead09983.jpg",
                IsInterval: false,
                MobileImage: "https://retinasociety.blob.core.windows.net/banner/6b003786-1c03-4dfd-ab22-d2f8ce01d136/a64f4ebac9be433fb5627b41f08a655d.jpg",
                Sort: 0,
                StartOn: "2019-08-08T00:00:00",
                Title: "banner1",
                UpdateOn: "2019-08-19T18:48:32.4353931",
                Url: "https://www.google.com.tw/"
            },
            {
                Active: true,
                CreateOn: "2019-08-08T17:52:11.150101",
                Deletion: false,
                EndOn: "2019-08-31T00:00:00",
                Hash: "e360d8bb-1da5-4a48-840e-a8c878e6b4d0",
                Id: "27945489-4459-4ac1-84ee-f388fa0194de",
                Image: "https://retinasociety.blob.core.windows.net/banner/27945489-4459-4ac1-84ee-f388fa0194de/d6bb581ab9d2405b8883c6ae723df167.jpg",
                IsInterval: false,
                MobileImage: "https://retinasociety.blob.core.windows.net/banner/27945489-4459-4ac1-84ee-f388fa0194de/87cbbfb7aab84f038f54acf1c9aba6e8.jpg",
                Sort: 0,
                StartOn: "2019-08-08T00:00:00",
                Title: "banner3",
                UpdateOn: "2019-08-19T18:48:32.440409",
                Url: ""
            },
            {
                Active: true,
                CreateOn: "2019-08-08T17:51:50.8506596",
                Deletion: false,
                EndOn: "2019-08-31T00:00:00",
                Hash: "da84d935-2f71-4dc8-b321-fe84c8e012db",
                Id: "9d6e4f1d-6a1b-4410-84ea-20e492f8a3ad",
                Image: "https://retinasociety.blob.core.windows.net/banner/9d6e4f1d-6a1b-4410-84ea-20e492f8a3ad/6a5acbedf8444fbba5ca5fcf68ae2366.jpg",
                IsInterval: false,
                MobileImage: "https://retinasociety.blob.core.windows.net/banner/9d6e4f1d-6a1b-4410-84ea-20e492f8a3ad/024be0a2ec2b4d8eae4c78f4844d1112.jpg",
                Sort: 0,
                StartOn: "2019-08-08T00:00:00",
                Title: "banner2",
                UpdateOn: "2019-08-19T18:48:20.2495599",
                Url: ""
            }
        ];
        vm.tabArea = [
            {
                Id:"",
                Name:"全部",
                Title:"All",
                Sort:0,
                Image:null
            },
            {
                Id: "bb941e83-cedd-4bc1-b2a2-127688844b49",
                Name: "國外活動",
                Title: "International",
                Sort: 0,
                Image: null
            },
            {
                Id: "172a1a46-596a-4c07-8ba9-51b6a778c97d",
                Name: "地會",
                Title: "Mid_meeting",
                Sort: 0,
                Image: null
            },
            {
                Id: "9c6e32c0-1ed6-44c4-bd0d-ed5e9a949ade",
                Name: "年會",
                Title: "Annual_meeting",
                Sort: 0,
                Image: null
            },
            {
                Id: "e3ca867b-e423-4632-b7b5-f8e361d73f7e",
                Name: "國內活動",
                Title: "Domestic",
                Sort: 0,
                Image: null
            }
        ];
        let thisWeek = vm.computedWeek[0];
        vm.Week = thisWeek;
        vm.mock.news = [
          {
            Id: "7aecb625-4870-40af-a46d-4b6b80027ef3",
            StartOn: "2019-01-07",
            CategoryId: "視網膜醫學會",
            Title: "視網膜醫學會網站 全新改版，會員/準會員 登入說明～"
          },
          {
            Id: "7aecb625-4870-40af-a46d-4b6b80027ef3",
            StartOn: "2019-01-07",
            CategoryId: "視網膜醫學會",
            Title: "中華民國視網膜醫學會 民國108年 工作計畫"
          },
          {
            Id: "7aecb625-4870-40af-a46d-4b6b80027ef3",
            StartOn: "2019-01-07",
            CategoryId: "其他機關",
            Title: "轉知「醫策會20週年國際論壇」徵文訊息。"
          },
          {
            Id: "7aecb625-4870-40af-a46d-4b6b80027ef3",
            StartOn: "2019-01-07",
            CategoryId: "其他機關",
            Title: "轉知「醫策會20週年國際論壇」徵文訊息。"
          },
          {
            Id: "7aecb625-4870-40af-a46d-4b6b80027ef3",
            StartOn: "2019-01-07",
            CategoryId: "其他機關",
            Title: "轉知「醫策會20週年國際論壇」徵文訊息。"
          }
        ];
        vm.mock.activity.silhouettes = [
            {
              Id: "b8988ddb-51a0-4eef-8095-5ab6b7895001",
              Cover: "../static/images/activity/act01.jpg",
              Title: "第55次地方學術研討會",
              Introduction:
                "提供完整國內外研討會及每年各項學術年會與地會開辦及投稿日期時間，以便各位使用者查詢與確認，若有任何問題，可聯絡通知我們，通知我..."
            },
            {
              Id: "b8988ddb-51a0-4eef-8095-5ab6b7895002",
              Cover: "../static/images/activity/act02.jpg",
              Title: "第56次地方學術研討會",
              Introduction:
                "提供完整國內外研討會及每年各項學術年會與地會開辦及投稿日期時間，以便各位使用者查詢與確認，若有任何問題，可聯絡通知我們，通知我..."
            },
            {
              Id: "b8988ddb-51a0-4eef-8095-5ab6b7895003",
              Cover: "../static/images/activity/act03.jpg",
              Title: "第58次地方學術研討會",
              Introduction:
                "提供完整國內外研討會及每年各項學術年會與地會開辦及投稿日期時間，以便各位使用者查詢與確認，若有任何問題，可聯絡通知我們，通知我..."
            },
            {
              Id: "b8988ddb-51a0-4eef-8095-5ab6b7895004",
              Cover: "../static/images/activity/act04.jpg",
              Title: "第59次地方學術研討會",
              Introduction:
                "提供完整國內外研討會及每年各項學術年會與地會開辦及投稿日期時間，以便各位使用者查詢與確認，若有任何問題，可聯絡通知我們，通知我..."
            }
        ];
        // console.log(thisWeek)
        vm.showevents = vm.events;
        vm.advertising = [
            {
                Id: "61ffd50e-f7bd-4ee5-ae81-5dc379fec12a",
                Title: "廣告",
                Sort: 0,
                Url: "http://www.retina.org.tw/",
                Content: "測試",
                Image: "https://retinasociety.blob.core.windows.net/advertisement/61ffd50e-f7bd-4ee5-ae81-5dc379fec12a/6c8140041bed496cbb1495eaebb00d84.jpg",
                MobileImage: "https://retinasociety.blob.core.windows.net/advertisement/61ffd50e-f7bd-4ee5-ae81-5dc379fec12a/7cbadfc7f0044fe9b587f0f1ac881ca5.jpg",
                IsInterval: true,
                StartOn: "2019-09-11T00:00:00",
                EndOn: "2019-09-30T00:00:00"
            },
            {
                Id: "61ffd50e-f7bd-4ee5-ae81-5dc379fec1a",
                Title: "廣告",
                Sort: 0,
                Url: "http://www.retina.org.tw/",
                Content: "測試",
                Image: "https://retinasociety.blob.core.windows.net/advertisement/61ffd50e-f7bd-4ee5-ae81-5dc379fec12a/6c8140041bed496cbb1495eaebb00d84.jpg",
                MobileImage: "https://retinasociety.blob.core.windows.net/advertisement/61ffd50e-f7bd-4ee5-ae81-5dc379fec12a/7cbadfc7f0044fe9b587f0f1ac881ca5.jpg",
                IsInterval: true,
                StartOn: "2019-09-11T00:00:00",
                EndOn: "2019-09-30T00:00:00"
            }
        ];
    }
    vm.getVideo();
  },
  updated() {
    const vm = this;
    if (vm.banners.length > 0) {
        vm.swiper.init();
    }
    
    if(vm.advertising.length > 0){
        vm.swiperAD.init();
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  }
};
</script>
<style>
#index .m_5 {
    margin: 5px 0;
}
#index .mb_5 {
    margin-bottom: 5px;
}
#index .shadow {
    text-shadow: 1px 1px 2px #333;
}
#index .remark {
    text-shadow: 1px 1px 2px #333;
    font-weight: normal !important;
}
#index .idx_flex {
    display: flex;
    align-items: stretch;
    flex-wrap: wrap;
}
#index .banner_silder {
    margin-top: 131px;
}
#index video {
    width: 100%;
}
#index .banner {
    width: 100%;
    /* height: 728px; */
    padding-bottom: 25%;
    background-repeat: no-repeat;
    background-position: 80% 50%;
    background-size: cover;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
}
#index .banner.effect1 {
    /* color: #1b0562; */
    padding-left: 30px;
}
#index .banner.effect1 .box {
    width: 750px;
}
#index .banner.effect1 .box > .title {
    color: #1b0562;
    width: 100%;
    font-weight: 600;
    font-size: 4rem;
    text-align: center;
    line-height: 1.5;
}
#index .banner.effect1 .box > .subtitle {
    color: #1b0562;
    width: 100%;
    text-align: center;
    font-size: 2rem;
    font-weight: 600;
    margin-bottom: 20px;
}
#index .banner.effect1 .box > .content {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
#index .banner.effect1 .box > .content > .item {
    width: 48%;
    font-size: 1.5rem;
    font-weight: 600;
    line-height: 1.5;
    color: #fff;
    text-shadow: 0 2px #1b0562, 2px 0 #1b0562, -2px 0 #1b0562, 0 -2px #1b0562,
        -2px -2px #1b0562, 2px 2px #1b0562, -2px 2px #1b0562, 2px -2px #1b0562;
    text-align: center;
}
#index .banner.effect2 {
    color: #fff;
    text-align: center;
    line-height: 1.5;
    letter-spacing: 3px;
    padding-left: 10%;
}
#index .banner.effect2 > .box {
    max-width: 550px;
}
#index .banner.effect2 > .box > .title {
    font-size: 4rem;
    font-weight: 600;
}
#index .banner.effect2 > .box > .subtitle {
    font-size: 2rem;
    padding: 10px 0;
}
/* 舊的baneer CSS  */
#index .banner.effect3 {
    color: #fff;
}
#index .banner.effect3 > .box {
    max-width: 750px;
}
#index .banner.effect3 .year {
    letter-spacing: 5px;
    text-align: center;
}
#index .banner.effect3 .title {
    display: flex;
    justify-content: center;
    align-items: center;
}
#index .banner.effect3 .btn_box {
    display: flex;
    justify-content: center;
    padding: 15px;
}
#index .banner.effect3 .readmore {
    display: flex;
    align-items: center;
    background-color: #a59b92;
    width: 120px;
    border-radius: 15px;
    justify-content: space-between;
    color: #fff;
    text-decoration: none;
    height: 32px;
}
#index .banner.effect3 .readmore span {
    width: calc(100% - 32px);
    text-align: center;
    transition: 0.5s;
}
#index .banner.effect3 .readmore div {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 99px;
    background-color: #fff;
    width: 32px;
    height: 32px;
    transition: 0.5s;
}
#index .banner.effect3 .readmore:hover div {
    transform: rotate(-30deg);
}
#index .banner.effect3 .title .taiwan {
    writing-mode: vertical-lr;
}
#index .banner.effect3 .title .taiwan span {
    writing-mode: initial;
}
#index .banner.effect3 .title .retina {
    display: flex;
    align-items: center;
    font-size: 3.5rem;
    font-weight: 700;
}
#index .banner.effect3 .text {
    letter-spacing: 3px;
    line-height: 1.5;
    text-align: center;
}
#index .banner.effect3 .readmore div > img {
    width: 16px;
}

#index .news {
    width: 100%;
    /* height: 583px; */
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    padding: 30px 0;
}
#index .news .news_box {
    width: 70%;
    padding-right: 10%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    /* justify-content: space-between; */
}
#index .news  .list_box {
    margin:20px 0;
    /* height: calc(100% - 93px); */
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    /* background-color: #f7f7f7; */
}
#index .news .silhouette_box {
    width: 30%;
    height: 100%;
}
#index .news .silhouette_box .list_box {
    background-color:transparent;
}
/* #index .news .silhouette_box .list_box:after {
    content:"";
    flex: 1;
} */
/* #index .news .silhouette_box .list_box {
    display: flex;
    flex-direction: column;
    height: calc(100% - 93px);
    justify-content: space-between;
} */
#index .news .activity_box {
    display: flex;
    width: 70%;
    flex-wrap: wrap;
    justify-content: space-between;
}
#index .news .activity_box .teach_activity,
#index .news .activity_box .silhouette_activity {
    width: 49%;
    /* margin: 0 1%; */
    display: flex;
    flex-direction: column;
    /* flex-grow: 1; */
    justify-content: space-between;
    line-height: 1.5;
}

#index .news .activity_box .teach_activity .title_box,
#index .news .activity_box .silhouette_activity .title_box {
    display: flex;
    padding: 0 10px 18px;
}

#index .news .activity_box .title_box .title {
    width: 70%;
}
#index .news .activity_box .title_box .title .cht {
    font-size: 1.5rem;
}
#index .news .activity_box .title_box .swiper_button_box {
    display: flex;
    justify-content: flex-end;
    width: 30%;
}
#index .news .activity_box .title_box .swiper_button_box .swiper_prev,
#index .news .activity_box .title_box .swiper_button_box .swiper_next {
    width: 30px;
    height: 40px;
    padding: 5px;
    border: 1px solid #decdb2;
    color: #decdb2;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 25px;
    cursor: pointer;
}
#index .news .activity_box .title_box .swiper_button_box .swiper_prev {
    margin: 0 10px;
}

#index .stroke {
    padding: 40px 0;
}
#index .stroke .title_box {
    display: flex;
    flex-wrap: wrap;
}
#index .stroke .title_box .title {
    width: 70%;
}
#index .stroke .title_box .title .text {
    line-height: 1.5;
    margin-top: 15px;
}
#index .stroke .title_box .calendar {
    width: 30%;
    display: flex;
    justify-content: flex-end;
    padding: 10px 0;
}
#index .stroke .title_box .calendar .border {
    width: 150px;
    border: 1px solid #ddd;
    border-radius: 2px;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    text-align: center;
    color: #aaa;
    line-height: 1.3;
    text-decoration: none;
    cursor: pointer;
    transition: 0.5s;
}
#index .stroke .title_box .calendar .border:hover {
    box-shadow: 0 14px 28px rgba(238, 139, 89, 0.25),
        0 10px 10px rgba(238, 139, 89, 0.22);
}
#index .stroke .title_box .calendar .border .icon {
    font-size: 50px;
}
#index .stroke .tab {
    display: flex;
    flex-wrap: wrap;
    margin: 15px auto;
}
#index .stroke .tab .tab_button {
    width: 76px;
    border-right: 3px solid #ee8b59;
}
#index .stroke .tab .tab_button .link_tab {
    height: 165px;
    padding: 30px 10px;
    -webkit-writing-mode: vertical-rl;
    writing-mode: vertical-rl;
    text-align: center;
    line-height: 1.5;
    /* background-color: #fcc; */
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.08), 0 3px 6px rgba(0, 0, 0, 0.16);
    border-radius: 5px 0 0 5px;

    cursor: pointer;
    -moz-user-select: none; /* for Firefox */
    -webkit-user-select: none; /* for Chrome */
    user-select: none;
    color: #666;
    margin-right: 5px;
    transition: 0.5s;
}
#index .stroke .tab .tab_button .link_tab + .link_tab {
    margin-top: 5px;
}
#index .stroke .tab .tab_button .link_tab.active {
    background-color: #ee8b59;
    color: #fff;
    margin-right: 0px;
    padding: 30px 13px;
    box-shadow: none;
}
#index .stroke .tab .tab_content {
    width: calc(100% - 76px);
    background-color: #eee;
    padding: 20px 30px;
}
#index .stroke .tab .tab_content .month {
    padding: 20px;
    text-align: center;
    color: #666;
}
#index .stroke .tab .tab_content .date {
    text-align: center;
    font-size: 1.75rem;
}
#index .stroke .tab .tab_content .classification {
    width: 80%;
    margin: 20px auto;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
}
#index .stroke .tab .tab_content .classification .item {
    border-radius: 5px;
    background-color: #fff;
    padding: 10px 0;
    width: calc(20% - 10px);
    text-align: center;
    -moz-user-select: none; /* for Firefox */
    -webkit-user-select: none; /* for Chrome */
    user-select: none;
    cursor: pointer;
    position: relative;
    line-height: 1.2;
    font-size: 0.9rem;
    margin-bottom: 15px;
}
#index .stroke .tab .tab_content .classification .item +.item {
    margin-left: 10px;
}
#index .stroke .tab .tab_content .classification .item::after {
    content: "";
    position: absolute;
    top: 0;
    /* left: 0; */
    right: -2px;
    bottom: 0;
    margin: auto;
    /* width: 0; */
    border: 2px solid rgba(0, 0, 0, 0.35);
    border-radius: 5px;
    transition: 0.5s;
    opacity: 0;
    width: 50%;
    height: 40px;
}
#index .stroke .tab .tab_content .classification .item.active:after {
    /* border: 1px solid rgba(0, 0, 0, 0.35); */
    opacity: 1;
    height: 100%;
    width: 100%;
}
#index .slider {
    /* margin: 60px 0; */
    background-color: #eee;
    padding: 60px 0;
}

/* swiper */
.swiper-slide.active {
    width: 100% !important;
    padding: 0 10px;
}
.swiper-container-horizontal > .swiper-scrollbar {
    display: none;
}
.swiperAd {
    width: 100%;
    display: block;
    font-size: 0;
}
.swiperAd img{
    width: 100%;
}

@media screen and (max-width: 1200px) {
    #index .banner_silder {
        margin-top: 70px;
    }
}
@media screen and (max-width: 992px) {
    #index .banner_silder {
        margin-top: 70px;
    }
    #index .stroke .tab .tab_content .classification .item +.item {
        margin-left: 0;
    }
}
@media screen and (max-width: 992px) {
    #index .banner {
        justify-content: flex-start;
        /* padding-top: 150px; */
        padding-bottom: 75%;
        padding-left: 0;
        padding-right: 0;
        background-position: 76% 50%;
    }
    #index .banner.effect1 {
        padding: 0;
    }
    #index .banner.effect1 > .box {
        width: 100%;
        height: 700px;
        padding-top: 120px;
        background-color: rgba(255, 255, 255, 0.5);
    }
    #index .banner.effect1 .box > .title {
        font-size: 3rem;
    }
    #index .banner.effect1 .box > .subtitle {
        font-size: 1.5rem;
    }
    #index .banner.effect2 {
        padding-top: 100px;
        padding-left: 0;
    }
    #index .banner.effect2 .box {
        margin: auto;
    }
    #index .banner.effect2 .box > .title {
        font-size: 3rem;
    }
    #index .banner.effect2 .box > .subtitle {
        font-size: 1.5rem;
    }
    #index .banner.effect3 {
        padding-top: 200px;
    }
    #index .news .news_box,
    #index .news .activity_box,
    #index .news .silhouette_box {
        width: 100%;
    }
    #index .news .silhouette_box .list_box {
        height: 440px;
    }
    #index .news .activity_box .teach_activity,
    #index .news .activity_box .silhouette_activity {
        width: 100%;
        margin: 15px 0;
    }
    #index .stroke .title_box .title {
        width: 100%;
    }
    #index .stroke .title_box .calendar {
        width: 40%;
        margin: auto;
    }
    /* 行事曆 */
    #index .stroke .tab .tab_button {
        width: 100%;
        border: none;
    }
    #index .stroke .tab .tab_button .link_tab {
        width: 100%;
        height: 70px;
        writing-mode: lr-tb;
        padding: 10px;
        border-radius: 0px;
        box-shadow: none;
        border: 1px solid #eee;
    }
    #index .stroke .tab .tab_button .link_tab + .link_tab {
        margin: 0;
    }
    #index .stroke .tab .tab_button .link_tab.active {
        padding: 10px;
    }
    #index .stroke .tab .tab_content {
        width: 100%;
        padding: 20px 10px;
    }
    #index .stroke .tab .tab_content .date {
        font-size: 1.3rem;
        width: 60%;
        margin: auto;
        line-height: 1.5;
    }
    #index .stroke .tab .tab_content .classification {
        width: 100%;
    }
    #index .stroke .tab .tab_content .classification .item {
        width: 100%;
        margin-bottom: 15px;
    }
    .swiper-slide img {
        width: 100%;
    }
    #index .news .activity_box .teach_activity .title_box,
    #index .news .activity_box .silhouette_activity .title_box {
        padding: 0;
    }
    /* swiper */
    #index .swiper-slide.active {
        padding: 0;
    }
    #index .swiper-button-next,
    #index .swiper-container-rtl .swiper-button-prev.banner-button-prev {
        background-image: url("data:image/svg+xml;charset=utf-8,<svg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'><path%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23FFFFFF'%2F><%2Fsvg>") !important;
    }
    #index .swiper-button-prev,
    #index .swiper-container-rtl .swiper-button-next {
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23ffffff'%2F%3E%3C%2Fsvg%3E") !important;
    }
}

/* 22/01/04 首頁影片用 */
.content .video{
position: relative;
padding-bottom: 56.25%;
padding-top: 30px;
height: 0;
overflow: hidden;
}

.content .video iframe, .video object, .video embed {
position: absolute;
top: 0;left: 0;
width: 100%;
height: 100%;
}
.silhouetteCard {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid #ccc;
    padding: 5px 5px 5px 10px;
    overflow: hidden;
    position: relative;
    color: #888;
    text-decoration: none;
    background-color: rgba(255, 255, 255, 0.3);
    transition: 0.35s;
}
.silhouetteCard + .silhouetteCard {
    margin-top: 20px;
}
.silhouetteCard:hover {
    color: #ee8b59;
    color: #fff;
}

.silhouetteCard:hover::after {
    width: 100%;
}
.silhouetteCard:after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 5px;
    height: 100%;
    background-color: #bab1a2;
    z-index: 50;
    transition: 0.5s;
}
.silhouetteCard .title {
    width: 48%;
    position: relative;
    z-index: 51;
    letter-spacing: 2px;
    line-height: 1.5;
}

.silhouetteCard .image {
    width: 48%;
    font-size: 0;
    overflow: hidden;
    position: relative;
    z-index: 51;
    padding-top: 30%;
    background-color: #fff;
}
.silhouetteCard .image img {
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    transform: scale(1) translateY(-50%);
    /* max-width: 100%; */
    max-height: 100%;
    transition: 0.8s;
    margin: auto;
}
.silhouetteCard:hover img {
    transform: scale(1.2) translateY(-50%);
}
@media screen and(max-width:767px) {
    .silhouetteCard .image {
        padding-top: 23%;
    }
}
</style>
<style scoped>
#videoplatform .remark {
    margin-bottom: 30px;
    text-align: center;
}
#videoplatform .list_box {
    margin-bottom: 60px;
}
#videoplatform .list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: stretch;
}
#videoplatform .list::after {
    content: "";
    flex: 0 0 30%;
    width: 30%;
    max-width: 350px;
}
#videoplatform .list .item {
    width: 30%;
    max-width: 350px;
    margin-bottom: 25px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    padding-bottom: 20px;
}
#videoplatform .detail .video_box {
    border: 8px solid #eee;
    padding: 30px 10px;
}
#videoplatform .detail .video_box .date {
    color: #666;
    padding: 10px 20px;
    letter-spacing: 2px;
    font-size: 1.1rem;
}
#videoplatform .detail .video_box .title {
    color: #666;
    font-size: 1.4rem;
    padding: 0 20px 20px;
    letter-spacing: 2px;
    line-height: 1.5;
    border-bottom: 1px solid #aaa;
    margin-bottom: 20px;
}
#videoplatform .detail .video_box .video {
    width: 90%;
    margin: auto;
    padding: 40px 0;
}
#videoplatform .detail .video_box .video video {
    width: 100%;
}
#videoplatform .detail .video_box .remark {
    color: #666;
    letter-spacing: 2px;
    line-height: 1.2;
}
#videoplatform .detail .video_box .download {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px auto;
    width: 165px;
}
@media screen and (max-width: 992px) {
    #videoplatform .list .item {
        width: 48%;
        max-width: none;
    }
}
@media screen and (max-width: 767px) {
    #videoplatform .list .item {
        width: 100%;
        margin: 0 auto 30px;
        max-width: none;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/index.vue